module.exports = __webpack_public_path__ + "phone.4e04eb977c83b7ca1764f406db816053.svg";